export enum AccordionMode {
  DEFAULT = 'default',
  COLLAPSIBLE = 'collapsible',
  MULTIPLE = 'multiple'
}

export interface AccordionChangeEvent {
  index: number;
  isOpen: boolean;
}
